import { ClickTypes } from '../types';
import React from 'react';

export const DATA_ICON_SIZE = 12;

export function noop() {
  /* no operation */
}

export function getClickTypeColor(clickType: ClickTypes): 'red' | 'green' | 'blue' | 'yellow' {
  switch (clickType) {
    case 'clicked':
      return 'blue';
    case 'error_clicked':
      return 'red';
    case 'rage_clicked':
      return 'green';
    case 'dead_clicked':
      return 'yellow';
  }
}

export const getElementAreaIfMouseEventRelated = (
  e: React.MouseEvent<HTMLElement>,
  element: Pick<HTMLElement, 'getBoundingClientRect'>,
) => {
  const boundingClientRect = element.getBoundingClientRect();
  const offsetTop = boundingClientRect.top;
  const offsetLeft = boundingClientRect.left;
  const x = e.clientX;
  const y = e.clientY;
  if (
    y >= offsetTop &&
    y <= offsetTop + boundingClientRect.height &&
    x >= offsetLeft &&
    x <= offsetLeft + boundingClientRect.width
  ) {
    return boundingClientRect.height * boundingClientRect.width;
  }

  return null;
};

export const NoElementDOMRect: DOMRect = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
  toJSON: () => {},
};
